export default __webpack_public_path__ + "static/media/fus.5984d13e.jpg";